import React from 'react'

import {
  AlertEmphasis,
  FormInfoAlert,
} from 'components/reusables/formInfoAlert'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from './common'

export const NormativeCertificateAssociationAlert: React.FC = () => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.normative.certificateAssociationAlert`,
  })

  return (
    <FormInfoAlert>
      {t('body1')}
      <AlertEmphasis>{t('navigationLabel')}</AlertEmphasis>
      {t('body2')}
    </FormInfoAlert>
  )
}
